export default __webpack_public_path__ + "static/media/detail_big_4_1.2ab7ed43.png";